module.exports = __webpack_public_path__ + "img/food-recommender-min.e9b71756.jpg";